<template lang="pug">
    div
        Card.a8-page-description-card
            Row(type="flex" align="middle" justify="space-between")
                    Col
                        h2 {{$t('originPolicy.pageTitleText')}}
                    Col
                        ExplainBtn(:objectExplanation="objectsExplanation")
            p Advanced origin strategy.
            strong You have created {{ usage.used }} of {{ usage.max }} origin policies.

        // h2 {{$t('originPolicy.pageTitleText')}}
        RcmTable(
            :esIndex="esIndex"
            :esIndexFields="esIndexFields"
            :addButtonText="addButtonText"
            :userCanCreate="true"
            :userCanIndex="true"
            :userCanDelete="true"
            :actionInTable="true"
            :userCanBatchEdit="false"
            :userCanSearchByTag="false"
            :drawerTitleKey="drawerTitleKey"
            ref="rcmTable"
            :searchView="searchView"
            :sectionInfo="sectionInfo"
            primarySearchKey="originPolicyName"
            :primarySearchKeyI18="$t('originPolicy.originPolicyName')"
            :isCreateBtnDisabled="!$can('write', 'domainManagePermission','OriginPolicies')"
            :isEditBtnDisabled="!$can('write', 'domainManagePermission','OriginPolicies')"
            :isDeleteBtnDisabled="!$can('write', 'domainManagePermission','OriginPolicies')"
        )
</template>
<script>
import Vue from "vue";

import RcmTable from "@/components/RcmTable_v2";
import TagList from "@/components/TagList";
import bus from "@/libs/bus.js";

import { getGroupAsset } from "@/api/groupasset.js";

import CopyText from "@/components/CopyText";
import JsonPoptip from "@/components/JsonPoptip";
import ObjectLogBtn from "@/components/ObjectLogBtn";

Vue.component("TagList", TagList);
Vue.component("CopyText", CopyText);
Vue.component("JsonPoptip", JsonPoptip);
Vue.component("ObjectLogBtn", ObjectLogBtn);

import {
    settingZoneExplain,
    groupName,
    // origins,
    originscheme,
    portMappingType,
    originPort,
} from "./fields.js";

export default {
    name: "OriginPolicy",
    components: { RcmTable, TagList },
    data() {
        return {
            searchView: "OriginPolicy",
            esIndex: "rcm-originpolicies",
            drawerTitleKey: "originPolicyName",
            assetCategory: "originPolicies",
            usage: { used: "", max: "", available: "" },
            objectsExplanation: {},
        };
    },
    computed: {
        addButtonText() {
            return this.$i18n.t("domainsetting.createText");
        },
        sectionInfo() {
            let sectionInfo = [{ sectionKey: "essential", isOpened: true }];

            sectionInfo = sectionInfo.map((e) => {
                e.sectionName = this.$i18n.t(`originPolicy.sections.${e.sectionKey}`);
                return e;
            });
            return sectionInfo;
        },
        esIndexFields() {
            return this.$store.getters.isAdmin
                ? {
                      action: {},
                      createBy: {},
                      settingZoneExplain: settingZoneExplain(this),
                      groupName: groupName(this),
                      originPolicyName: {},
                      _id: {},
                      usedByFQDNConfigLength: {},
                      // originRegion: {},
                      // origins: origins(this),
                      originsOptions: {},
                      originscheme: originscheme(this),
                      portMappingType: portMappingType(this),
                      originPort: originPort(this),
                      loadbalancerMethod: {},
                      loadbalancerSticky: {},
                      healthCheckMode: {},
                      healthCheckUri: {},
                      healthCheckHttpCode: {},
                      healthCheckInterval: {},
                      healthCheckTimeout: {},
                      healthCheckSuccess: {},
                      healthCheckFail: {},
                      createdDate: {},
                      modifiedDate: {},
                      status: {},
                      objectLog: {},
                  }
                : {
                      action: {},
                      createBy: {},
                      settingZoneExplain: settingZoneExplain(this),
                      groupName: groupName(this),
                      originPolicyName: {},
                      _id: {},
                      usedByFQDNConfigLength: {},
                      // originRegion: {},
                      // origins: origins(this),
                      originsOptions: {},
                      originscheme: originscheme(this),
                      portMappingType: portMappingType(this),
                      originPort: originPort(this),
                      loadbalancerMethod: {},
                      loadbalancerSticky: {},
                      healthCheckMode: {},
                      healthCheckUri: {},
                      healthCheckHttpCode: {},
                      healthCheckInterval: {},
                      healthCheckTimeout: {},
                      healthCheckSuccess: {},
                      healthCheckFail: {},
                      createdDate: {},
                      modifiedDate: {},
                      status: {},
                      objectLog: {},
                  };
        },
    },
    watch: {
        "$store.state.rcmTableIsInitComplete": function (newVal, oldVal) {
            if (this.$router.currentRoute.query.create && newVal) {
                this.$refs.rcmTable.manipulateItem("", "create");
            }
        },
        "$i18n.locale": {
            deep: true,
            handler: function () {
                this.objectsExplanation = this.$i18n.t("objectExplanation." + this.esIndex);
            },
        },
    },
    methods: {
        getAssetData() {
            getGroupAsset({
                category: this.assetCategory,
                groupNames: [this.$store.state.queryGroupName],
            }).then((res) => {
                let { used, max } = res.data;
                let available = max - used;
                this.usage = { used, max, available };
            });
        },
    },
    mounted() {
        this.getAssetData();
    },
    created() {
        this.objectsExplanation = this.$i18n.t("objectExplanation." + this.esIndex);
        // this.isAdmin = this.$store.state.userData.privilege == "admin";
        this.$bus = bus;
        // 監聽以自己組件為名的事件
        bus.$on(this.$options.name, (busEvent, args) => {
            // 如果是找我的事件就接收處理, 否則向下傳遞
            switch (busEvent) {
                case "":
                    break;
                default:
                    bus.$emit(busEvent);
                    break;
            }
        });
    },
    destroyed() {},
    beforeDestroy() {
        bus.$off(this.$options.name);
    },
};
</script>



// WEBPACK FOOTER //
// src/view/OriginPolicy/Page.vue